import styled from '@emotion/styled';

import CompanyLogo from '../../../components/CompanyLogo/CompanyLogo';
import BookmarkIcon from '../../../components/Icons/BookmarkIcon';
import HeaderSettingsIcon from '../../../components/Icons/HeaderSettingsIcon';
import MenuIcon from '../../../components/Icons/MenuIcon';
import { InternalNavLink } from '../../../components/Link/Link';
// import { BOOKMARKS, USERS_SETTINGS } from '../../routes/routeConstants';

import HeaderModalButton from './HeaderModalButton';
import HealthHeaderDropDown from './HealthHeaderDropDown';
import NotificationIcon from '../../../components/Icons/NotificationIcon';
import { useAppSelector } from '../../../redux/store';
// import NotificationIndicator from '../../../components/NotificationIndicator/NotificationIndicator';

interface IHeader {
  open?: boolean;
  toggleNav: (...arg: any) => void;
  guest?: boolean;
}

const DashboardHeader: React.FC<IHeader> = ({ open, toggleNav }) => {
  const { authData } = useAppSelector((state) => state.auth);

  return (
    <Container>
      <OptionalLogo>
        <CompanyLogo goHome/>
      </OptionalLogo>
      <Health>{authData?.institutionName}</Health>
      <HeaderModalButton className="mobileonly">Post a Job</HeaderModalButton>
      <MobileDiv>
        {/* <NotificationIndicator /> */}
        <MenuButton onClick={() => toggleNav()}>
          <MenuIcon />
        </MenuButton>
      </MobileDiv>

      <IconsContainer>
        <HeaderModalButton>Post a Job</HeaderModalButton>
        <IconWrapper>
          <InternalNavLink to={``}>
            <BookmarkIcon />
          </InternalNavLink>
        </IconWrapper>

        <IconWrapper>
          <InternalNavLink to={``}>
            <NotificationIcon />
          </InternalNavLink>
        </IconWrapper>

        {/* <NotificationIndicator /> */}

        <IconWrapper>
          <InternalNavLink to={``}>
            <HeaderSettingsIcon />
          </InternalNavLink>
        </IconWrapper>

        <IconWrapper>
          <HealthHeaderDropDown />
        </IconWrapper>
      </IconsContainer>
    </Container>
  );
};

export default DashboardHeader;

const Container = styled.div`
  height: 5rem;
  background-color: white;
  position: sticky;
  top: 0;
  z-index: 1000;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 32px;
  padding: 0rem 6.25rem 0rem 3.38rem;

  @media (max-width: 884px) {
    display: flex;
    justify-content: space-around;
    padding: 0;
    width: 100vw;
    right: 0;
  }
`;

const IconsContainer = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  z-index: 2;

  @media (max-width: 884px) {
    display: none;
  }
`;

const IconWrapper = styled.div`
  cursor: pointer;

  & svg {
    min-width: 30px;
  }
`;

export const MenuButton = styled.div`
  display: none;
  background: none;
  outline: none;
  border: none;
  padding: 0;
  margin: 0;

  @media (max-width: 884px) {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    cursor: pointer;
  }
`;

const OptionalLogo = styled.div`
  display: none;

  @media (max-width: 884px) {
    display: grid;
  }
`;

const MobileDiv = styled.div`
  display: none;

  @media (max-width: 884px) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
  }
`;

const Health = styled.div`
  color: ${({ theme }) => theme.palette.mainBlue};
  font-weight: 500;
  font-size: 18px;
  letter-spacing: 0%;
  text-transform: uppercase;

  @media (max-width: 884px) {
    display: none;
  }
`;
